import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import "antd/dist/antd.css";

// SASS
import "./scss/main.scss";

// COMPONENTS
import TopNavigation from "./components/layouts/TopNavigation";
import Footer from "./components/layouts/Footer";

// PAGES
import Home from "./pages/Home";
import Error from "./pages/Error";

// IMAGES
import loadingLogo from "./img/logo.svg";

function App() {
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setLoader(false);
        }, 10000);
    }, []);

    return (
        <>
            <div
                className={
                    loader ? "pre-loader" : "pre-loader pre-loader__loaded"
                }
            >
                <div className="pre-loader__inner">
                    <img src={loadingLogo} alt="" />
                </div>
                <div className="box-wrapper">
                    <div className="box-1"></div>
                    <div className="box-2"></div>
                    <div className="box-3"></div>
                </div>
            </div>

            <TopNavigation />
            <Switch>
                <Route exact path="/" component={Home} />
                <Route exact component={Error} />
            </Switch>
            <Footer />
        </>
    );
}

export default App;
